<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true" :disabled="!power.oil_gun_add">新增</el-button>
                <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin" :disabled="!power.oil_gun_del">删除</el-button>
            </el-col>

            <!-- search start  -->
            <!-- <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 130px;">
                    <el-select v-model="data.searchSelect" placeholder="请选择titleSelect" size="small">
                        <el-option
                            v-for="item in [{id: 1, name: 'test_select'}]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.searchText" size="small" placeholder="请输入textContent" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col> -->
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="num" label="油枪编号" width="180"></el-table-column>
                    <el-table-column prop="param" label="油枪参数" width="180"></el-table-column>
                    <el-table-column prop="type" label="类型" width="180"></el-table-column>
                    <el-table-column prop="price" label="价格" width="180"></el-table-column>
                    <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
                    <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope">
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.oil_gun_add">编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain :disabled="!power.oil_gun_del">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="550px" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="油枪编号"
                    :label-width="formLabelWidth"
                    prop="num"
                    :rules="[
                    { required: true, message: '请输入油枪编号', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.num" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="油枪参数"
                    :label-width="formLabelWidth"
                    prop="param"
                    :rules="[
                    { required: true, message: '请选择油枪参数', trigger: 'blur' }
                    ]">
                    <el-select v-model="form.param" placeholder="请选择油枪参数" @change="paramChanage">
                        <el-option
                            v-for="item in [
                                {key: '0#', value: '0#'},
                                {key: '92#', value: '92#'},
                                {key: '95#', value: '95#'},
                                {key: '98#', value: '98#'}
                              ]"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型"
                    :label-width="formLabelWidth"
                    prop="type"
                    :rules="[
                    { required: true, message: '请选择类型', trigger: 'blur' }
                    ]">
                    <el-radio v-model="form.type" :label="1" border>汽油</el-radio>
                    <el-radio v-model="form.type" :label="2" border>柴油</el-radio>
                </el-form-item>
                <el-form-item label="价格"
                    :label-width="formLabelWidth"
                    prop="price"
                    :rules="[
                    { required: true, message: '请输入价格', trigger: 'blur' }
                    ]">
                    <el-input type="number" readonly v-model="form.price" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {OilGunIndex, OilGunAdd, OilGunDel} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    searchSelect: '',
                    searchText: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增油枪",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    num: "",
                    param: "",
                    type: 1,
                    price: "",
                },
                multipleSelection: [],
                oilList: []
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                OilGunIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                        this.oilList = res.data.oilList
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        OilGunAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    num: data.num,
                    param: data.param,
                    type: data.type,
                    price: data.price,
                }
                this.dialogTitle = this.form.id > 0 ? "编辑油枪" : "新增油枪"
                this.dialogFormVisible = true
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    num: "",
                    param: "",
                    type: 1,
                    price: "",
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增油枪"
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            delMultiple() {
                if (this.multipleSelection.length == 0) {
                    this.$message.error("请至少选择一项你要删除的项");
                    return
                }
                this.del(this.multipleSelection)
            },
            del(id) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    OilGunDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
            paramChanage(value) {
              this.oilList.forEach(item => {
                if (item.key == value) {
                  this.form.price = item.price
                }
              })
            }
        }
    }
</script>

<style>
</style>
